var _ = require('underscore');
var TorsoView = require('backbone-torso/modules/View');
var descriptiveTextQuestionTemplate = require('./descriptiveTextQuestionTemplate.hbs');
var surveyItemCollection = require('./surveyItemCollection');
var surveyLanguageService = require('./surveyLanguageService');

/**
 * The descriptiveTextQuestionView serves as the view that will render a descriptive text question of a survey.
 *
 * @class DescriptiveTextQuestionView
 *
 * @constructor
 * @param options {Object}
 *   @param options.surveyItemId {Number} The id of the survey item to display.
 *   @param options.languageKey {String} the key of the language.
 *   @param options.$multimedia {Element} A jquery DOM element that contains any multimedia to display as part of this question.
 */
module.exports = TorsoView.extend({
  className: 'portal-container portal-container--high-contrast',
  template: descriptiveTextQuestionTemplate,

  /**
   * @method initialize
   * @override
   * @param options {Object}
   *   @param options.surveyItemId {Number} The id of the survey item to display.
   *   @param options.languageKey {String} the key of the language.
   *   @param options.$multimedia {Element} A jquery DOM element that contains any multimedia to display as part of this question.
   */
  initialize: function(options) {
    /**
     * @property _surveyItemId {Number} the id of the survey item to display.
     * @private
     */
    this._surveyItemId = options.surveyItemId;

    /**
     * @property _surveyItemCollection {TorsoCollection} retriever collection for this view.  Only one id is registered.
     * @private
     */
    this._surveyItemCollection = surveyItemCollection.createPrivateCollection(this.cid);

    /**
     * @property _$multimedia {Element} A jquery DOM element that contains any multimedia to display as part of this question.
     * @private
     */
    this._$multimedia = options.$multimedia;

    _.bindAll(this, '_updateLanguagesAndModel');

    $.when(surveyLanguageService.getLanguage(options.languageKey),
           surveyLanguageService.getDefaultLanguage(),
           this._surveyItemCollection.trackAndFetch([ this._surveyItemId ]))
      .always(this._updateLanguagesAndModel);
  },

  /**
   * @method prerender
   * @override
   */
  prerender: function() {
    if (this._$multimedia) {
      this._$multimedia.remove();
    }
  },

  /**
   * @method prerender
   * @override
   */
  postrender: function() {
    if (this._$multimedia) {
      this.$el.prepend(this._$multimedia);
    }
  },

  /**
   * Update the languages and get the survey item model from the collection.  To be called once the languages and survey item
   * have been fetched.
   *
   * @method _updateLanguagesAndModel
   * @param surveyLanguage {Torso.NestedModel} the language defined by the survey.
   * @param defaultLanguage {Torso.NestedModel} the default language to use as defined by the surveyLanguageService.
   * @private
   */
  _updateLanguagesAndModel: function(surveyLanguage, defaultLanguage) {
    this._surveyLanguage = surveyLanguage;
    this._defaultLanguage = defaultLanguage;
    this.render();
  },

  /**
   * @method prepare
   * @override
   */
  prepare: function() {
    var surveyItemModel = this._surveyItemCollection && this._surveyItemCollection.get(this._surveyItemId);
    return {
      'doneLoading' : surveyItemModel !== null,
      'mainText': surveyItemModel ? surveyItemModel.getMainText(this._surveyLanguage, this._defaultLanguage) : ''
    };
  },

  /**
   * @method _dispose
   * @override
   */
  _dispose: function() {
    this._surveyItemCollection.dispose();
  }
});
